<div class="myModal">
  <div class="modal-header">
    <button (click)="exitModal(false)" class="close"  aria-label="close">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <p style="white-space: pre-line">{{ preferenceMessages.modal_star_content | translate }}</p>
    <form class="form" [formGroup]="form">
      <select formControlName="preferenceSelected" class="form-control">
          <option *ngFor="let option of optionsSelect" [value]="option.id">
            {{ option.titre }}
          </option>
      </select>
    </form>
  </div>
  <div class="modal-footer">
    <button aria-label="confirmer"[disabled]="(!form.valid)" (click)="valider()" class="btn btn-outline-primary" 
      aria-label="close">{{ preferenceMessages.modal_star_confirmer | translate }}</button>
    <button aria-label="retour" (click)="exitModal(false)" class="btn btn-outline-primary" 
      aria-label="close">{{ preferenceMessages.modal_star_retour | translate }}</button>
  </div>
</div>
